<template>
  <div class="page-sales-records">
    <div 
      v-for="(item, index) in list" 
      :key="index" 
      class="setup-item"
      :class="{ 'last-item': item.last }"
    >
      <div class="item-left">
        <div class="item-time">
          <div class="date">{{ item.time | formateTime('y/m/d') }}</div>
          <div>{{ item.time | formateTime('h:m') }}</div>
        </div>
        <div class="item-icon"><div class="icon" /></div>
      </div>
      <div class="item-right">{{ item.context }}</div>
    </div>
  </div>
</template>

<script>
import { formateTime } from '@/utils/time'
export default {
    filters: {
        formateTime
    },
    data() {
        return {
            list: []
        }
    },
    created() {
        this.initList();
    },
    methods: {
        // 初始化
        initList() {
            const vm = this;
            vm.list = vm.$route.params.expressDeliveryInfo;
            if (vm.list.length == 0) {
                vm.list = [
                    {
                        context: '该快递暂无揽件信息',
                        last: true
                    }
                ]
            }
        }
    }

    
}
</script>

<style lang="less" scoped>
.page-sales-records {
  width: 100%;
  height: 100%;
  background: #f6f9fa;
  padding: 0.1rem;
  box-sizing: border-box;
  background: #fff;
  border-radius: 0.05rem;
  font-size: 0.16rem;
  color: #434343;
  padding: 0.3rem 0.1rem;
  min-height: 100%;

  .setup-item {
    display: flex;
    justify-content: space-between;
    padding-bottom: 0.2rem;
    min-height: 1rem;

    &.last-item {
      .item-left .item-icon::after {
        display: none;
      }
      .item-right {
        padding-top: 0.05rem;
      }
    }

    .item-left {
      display: flex;
      width: 1.05rem;
      font-size: 0.12rem;
      letter-spacing: 0.02rem;

      .date {
        font-size: 0.14rem;
      }

      .icon {
        width: 0.15rem;
        height: 0.15rem;
        background: #209a56;
        border-radius: 50%;
      }

      .item-time {
        text-align: right;
        width: 1.05rem;
      }

      .item-icon {
        padding-top: 0.1rem;
        width: 100%;
        text-align: center;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: space-between;
        position: relative;

        &::after {
          content: ' ';
          height: 0.3rem;
          border-left: 0.01rem solid #979797;
          position: absolute;
          top: 50%;
        }
      }
    }

    .item-right {
      width: 100%;
      span {
        color: #209a56;
        margin-left: 0.05rem;
      }
    }
  }
}
</style>